/**
 * Pricing JavaScript
 *
 * This file defines behaviors of
 * the Pricing block.
 */

document.querySelectorAll('.pricing')?.forEach((el, i) => {
	// set up popups
	const pop = el.querySelector('.popup--faux');
	const btn = el.querySelector('.popup-trigger a, a.popup-trigger');
	if (pop && btn) {
		pop.setAttribute('id', `popup-pricing-${i}`);
		btn.setAttribute('href', `#popup-pricing-${i}`);
	}

	// set up accordion
	el.querySelector('button.pricing__title')?.addEventListener('click', () =>
		el.classList.toggle('is-active')
	);

	// maybe populate form's hidden value
	const hidden = el.querySelector('.pricing-field input');
	if (hidden) {
		let str = '';
		['.pricing__title', '.pricing__price', '.pricing__term'].forEach(
			(selector) => {
				const piece = el.querySelector(selector)?.textContent;
				str += piece ? `${piece} ` : '';
			}
		);
		hidden.value = str || hidden.value;
	}
});
